/* @format */
export default {
    methods: {
        openHotelRoomRateChangedModal(response) {
            const { detail } = response;
            const currency = this.payload.hotelReservation.room.selectedRate.currency;
            const hotelRoomOldTotalPrice = this.$options.filters.currencyFilter(
                detail.hotelRoom.oldTotalPrice,
                currency
            );
            const hotelRoomNewTotalPrice = this.$options.filters.currencyFilter(
                detail.hotelRoom.newTotalPrice,
                currency
            );
            const giftCardAmountOld = detail.giftCard.oldAmount;
            const giftCardAmountNew = detail.giftCard.newAmount;
            const newTotalPrice = this.$options.filters.currencyFilter(
                detail.total.newTotalPrice,
                currency
            );
            const i18nPrefix =
                'main:views.eventV2.theEvent._components.eventHotelRoomRateChangedModal';
            const title = this.$t(`${i18nPrefix}.title`);
            const showContentWithGiftCard = !!giftCardAmountOld || !!giftCardAmountNew;
            let content;
            if (showContentWithGiftCard) {
                content = this.$t(`${i18nPrefix}.contentWithGiftCard`, {
                    oldPrice: hotelRoomOldTotalPrice,
                    newPrice: hotelRoomNewTotalPrice,
                    newTotalPrice: newTotalPrice,
                    newGiftCardValue: this.$options.filters.currencyFilter(
                        giftCardAmountNew,
                        currency
                    ),
                });
            } else {
                content = this.$t(`${i18nPrefix}.content`, {
                    oldPrice: hotelRoomOldTotalPrice,
                    newPrice: hotelRoomNewTotalPrice,
                    newTotalPrice: newTotalPrice,
                });
            }
            const cancelButton = this.$t(`${i18nPrefix}.buttons.cancel`);
            const confirmButton = this.$t(`${i18nPrefix}.buttons.confirm`);

            this.$modal.show(
                () => import('@tenant/app/components/modals/ConfirmationModal'),
                {
                    title,
                    content,
                    cancelButton,
                    confirmButton,
                    dataTestId: 'priceChangeConfirmation',
                    onCancelFn: () => {
                        this.navigateBack();
                        response && this.callbackAddItemToCartErrorFn(response);
                    },
                    onConfirmFn: () => this.onConfirmHotelRateChange(detail),
                },
                {
                    'max-width': 858,
                    persistent: true,
                }
            );
        },
        onConfirmHotelRateChange(rateChange) {
            const { selectedRate } = this.payload.hotelReservation.room;
            const { newTotalPrice, oldTotalPrice, newRateId } = rateChange.hotelRoom;

            selectedRate.netPrice = newTotalPrice;
            selectedRate.totalPrice = newTotalPrice;
            selectedRate.oldTotalPrice = oldTotalPrice;
            selectedRate.id = newRateId;
            selectedRate.totals.basePrice = newTotalPrice;

            if (!selectedRate.giftCard) {
                selectedRate.giftCard = {
                    amount: 0,
                    currency: selectedRate.currency,
                };
            }
            selectedRate.giftCard.amount = rateChange.giftCard.newAmount;

            this.showProgressAnimationModal(this.payload);
        },
        navigateBack() {
            if (this.previousRoute.fullPath !== this.$route.fullPath) {
                this.$router.replace(
                    this.previousRoute?.fullPath || {
                        name: this.routeRedirectOnError,
                        params: { id: this.$route.params.id },
                    }
                );
            }
        },
    },
};
